__turbopack_context__.v({
  "animatedBackground": "style-module-scss-module__CPecca__animatedBackground",
  "breadcrumbs": "style-module-scss-module__CPecca__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__CPecca__breadcrumbsWrap",
  "content": "style-module-scss-module__CPecca__content",
  "description": "style-module-scss-module__CPecca__description",
  "title": "style-module-scss-module__CPecca__title",
  "video": "style-module-scss-module__CPecca__video",
  "videoWrapper": "style-module-scss-module__CPecca__videoWrapper",
  "wrapper": "style-module-scss-module__CPecca__wrapper",
});
